module.exports = __webpack_public_path__ + "img/cart-outline.a14604a.svg";